import { useSelector } from "react-redux";
import { selectImpersonatedUserName, selectIsImpersonating } from "./ImpersonationSlice";

export const ImpersonationBanner = () => {
  const isImpersonating = useSelector(selectIsImpersonating);
  const impersonatedUserName = useSelector(selectImpersonatedUserName);

  if (!isImpersonating) return <></>;

  return (
    <div className="alert bg-primary d-flex flex-column flex-sm-row px-5 align-items-center mb-2 mt-4">
      <span className="fa-thin fa-face-disguise fa-xl text-white me-4"></span>
      <div className="d-flex flex-column pe-0 pe-sm-10 text-dark">
        <h5 className="mb-1 text-white">Impersonation Mode</h5>
        <span className="mb-1 text-white">
          You are currently in impersonator mode viewing the portal as {impersonatedUserName}
        </span>
      </div>
    </div>
  );
};
